<template>
  <div class="seg-info-exs">
    <div class="seg-exs-row">
      <template v-for="(acl, aclIndex) in seg.ancillaries">
        <div :key="aclIndex" class="_exs-col" v-if="acl.productType === 'MEAL'">
          <span class="exs-label">付费机餐:</span>
          <span class="exs-value">{{ acl.productName }}</span>
          <span class="exs-actions" v-if="exsEditAble">
            <span class="seg-href" @click="aclDetailHandler(acl)">详情</span>
            <span class="seg-href" v-if="acl.status === 'PF' || acl.status === 'WP'" @click="aclRefundHandler(acl)">{{ acl.status === 'PF' ? '退订' : '取消' }}</span>
          </span>
        </div>
        <div :key="aclIndex" class="_exs-col" v-if="acl.productType === 'LUGGAGE'">
          <span class="exs-label">预付费行李:</span>
          <span class="exs-value">{{ acl.productName }}</span>
          <span class="exs-actions" v-if="exsEditAble">
            <span class="seg-href" @click="aclDetailHandler(acl)">详情</span>
            <span class="seg-href" v-if="acl.status === 'PF' || acl.status === 'WP'" @click="aclRefundHandler(acl)">{{ acl.status === 'PF' ? '退订' : '取消' }}</span>
          </span>
        </div>
        <div :key="aclIndex" class="_exs-col" v-if="acl.productType === 'SEAT'">
          <span class="exs-label">预选座位:</span>
          <span class="exs-value">{{ acl.status === 'XX' ? '已取消' : acl.productName }}</span>
          <span class="exs-actions" v-if="exsEditAble">
            <span class="seg-href" @click="aclDetailHandler(acl)">详情</span>
            <span class="seg-href" v-if="acl.status === 'PF' || acl.status === 'WP'" @click="aclRefundHandler(acl)">{{ acl.status === 'PF' ? '退订' : '取消' }}</span>
          </span>
        </div>
      </template>
      <div class="_exs-col" v-if="insurances.length">
        <span class="exs-label">保险：</span>
        <span class="exs-tips">
        <template v-for="(ins, insIndex) in insurances">
          <a-popover
            :key="insIndex"
            trigger="click"
            overlayClassName="l8-order-popover order-primary-popover"
            placement="bottom">
          <template slot="content">
            <div class="popover-detail-table">
              <table>
                <tr>
                  <td>保险单号</td>
                  <td>{{ ins.orderNo || '--' }}</td>
                </tr>
                <tr>
                  <td>详情</td>
                  <td>{{ ins.desc }}</td>
                </tr>
                <tr>
                  <td>费用</td>
                  <td>{{ ins.amount }}元</td>
                </tr>
                <tr>
                  <td>状态</td>
                  <td>{{ ins.statusCn }}</td>
                </tr>
              </table>
            </div>
            <div class="popover-detail-footer"  v-if="exsEditAble && showInsRefund(ins)">
              <div class="seg-href" @click="insRefundHandler(ins)">{{ ['BH', 'WP'].indexOf(ins.status) >= 0 ? '取消保险' : '退订保险' }}</div>
            </div>
          </template>
          <template slot="title">
            <span>{{ ins.productName }}</span>
          </template>
          <span class="exs-tip"><span class="v-m">{{ ins.productName }}</span><l8-icon class="l8-icon" type="icon-sanx-up"/></span>
        </a-popover>
        </template>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { refundExtProduct } from '@/apis/order'
import { cancelExtProduct } from '@/apis/ancillary'
import moment from 'moment'
import queryString from 'query-string'
import { userTypeMap } from '@/dicts/member'

const mainSettings = window.__MICRO_ROOT__ ?? {}
const airline = mainSettings.airline

export default {
  name: 'ExtendInfo',
  props: {
    seg: {
      type: Object,
      default: function () {
        return {}
      }
    },
    order: {
      type: Object
    }
  },
  computed: {
    exsEditAble: function () {
      return typeof this.$attrs['exs-action'] !== 'undefined' ? this.$attrs['exs-action'] : true
    }
  },
  data () {
    return {
      insurances: [],
      userId: ''
    }
  },
  watch: {
    seg: function () {
      this.initIns()
    }
  },
  created () {
    const query = queryString.parse(location.search)
    const userInfo = mainSettings.user?.get()
    if (userInfo) {
      if (userTypeMap[userInfo.userType] === 'CARRIER') {
        this.userId = query.outUserId
      }
    }
    this.initIns()
  },
  methods: {
    initIns () {
      let insStatusMap = {
        // UNI提供枚举
        'BI': '初始状态',
        'BH': '购保处理中',
        'RF': '已退订',
        'RB': '退保失败',
        'WP': '等待支付',
        'HP': '购保处理中',
        'SB': '购保失败',
        'XX': '已取消',
        'PF': '保单已支付',
        'UN': '未知状态',
        // 旧版枚举
        'BF': '购保成功',
        'BS': '保单已提交',
        'RH': '退保处理中',
        'SS': '暂停使用',
        'OH': '单独退保处理中',
        'OF': '单独退保成功',
        'IE': '购保失败(航联)',
        'RE': '退保失败(航联)'
      }

      this.insurances = _.filter(this.seg.ancillaries, (acl) => {
        if (acl.productType === 'INSURANCE') {
          acl.statusCn = insStatusMap[acl.status]
          return true
        } else {
          return false
        }
      })
    },
    showInsRefund (ins) {
      if (['BH', 'BF', 'SB', 'WP'].indexOf(ins.status) < 0) {
        return false
      } else {
        if (ins.status === 'BH') { // 取消保险限制
          if (this.order.status !== 'WP') {
            return false
          }
        } else if (['BF', 'SB'].indexOf(ins.status) > -1) { // 退订保险限制
          if (ins.productName === '退票险') {
            return false
          }
        }

        if (ins.productName === '航班延误险' && ['BF', 'SB'].indexOf(ins.status) > -1) {
          return false
        }

        if (ins.productName === '行李险') {
          if (moment(this.seg.departureTime).subtract(1, 'days').isBefore(moment())) {
            return false
          }
        }
      }

      return true
    },
    aclDetailHandler (acl) {
      const query = {
        subOrderNo: acl.orderNo,
        id: acl.id
      }

      if (this.userId) {
        query.outUserId = this.userId
      }

      this.$router.push({
        path: '/ancillary/v2/subDetail',
        query
      })
    },
    aclRefundHandler (acl) {
      if (acl.status === 'WP') {
        this.$modal.confirm({
          title: '提示',
          content: '确定取消该产品吗？',
          cancelText: '取消',
          okText: '确认',
          onOk: () => {
            let data = {
              airline,
              orderId: this.order.orderId,
              segId: this.seg.id,
              detailIds: [
                acl.id
              ],
              type: 'OTHER'
            }
            return this.cancelExtProduct(data, acl)
          }
        })
      } else {
        this.$modal.confirm({
          title: '提示',
          content: '确定退订该产品吗？',
          cancelText: '取消',
          okText: '确认',
          onOk: () => {
            let data = {
              orderIds: [
                acl.id
              ],
              orderId: this.order.orderId,
              refundType: 'UNCONSTRAINT',
              remark: '',
              type: 'OTHER'
            }
            return this.refundExtProduct(data, acl)
          }
        })
      }
    },
    insRefundHandler (ins) {
      if (['BH', 'WP'].indexOf(ins.status) >= 0) {
        this.$modal.confirm({
          title: '提示',
          content: '确定取消该保险吗？',
          cancelText: '取消',
          okText: '确认',
          onOk: () => {
            let data = {
              orderId: this.order.orderId,
              airline,
              segId: this.seg.id,
              detailIds: [
                ins.id
              ],
              type: 'INSURANCE'
            }
            this.cancelExtProduct(data, ins)
          }
        })
      } else {
        this.$modal.confirm({
          title: '提示',
          content: '确定退订该保险吗？',
          cancelText: '取消',
          okText: '确认',
          onOk: () => {
            let data = {
              orderId: this.order.orderId,
              airline,
              segId: this.seg.id,
              orderIds: [
                ins.id
              ],
              refundType: 'UNCONSTRAINT',
              remark: '',
              type: 'INSURANCE'
            }
            this.refundExtProduct(data, ins)
          }
        })
      }
    },
    cancelExtProduct (data, acl) {
      return cancelExtProduct(data).then((res) => {
        acl.status = 'XX'
        this.$message.success('辅营订单取消成功, 正在刷新...')
        this.$emit('exs-action', data, 'cancel')
      }).catch((error) => {
        this.$message.error(error.message || '取消辅营失败，请稍候重试。')
      })
    },
    refundExtProduct (data, acl) {
      refundExtProduct(data).then((res) => {
        acl.status = 'XX'
        this.$message.success('辅营订单退订成功, 正在刷新...')
        this.$emit('exs-action', data, 'refund')
      }).catch((error) => {
        this.$message.error(error.message || '退订辅营失败，请稍候重试。')
      })
    }
  }
}
</script>
